export default __webpack_public_path__ + "static/media/icon-dsm.f62b2c6a.svg";